import React from 'react'
import { ChatDots } from 'phosphor-react'
import { styled, Avatar, Chip, useTheme } from '@material-ui/core'

const StyledChip = styled(Chip)(() => ({
  fontSize: '0.65rem',
}))

export function CollectStatus({ label, statusId }) {
  const theme = useTheme()

  return (
    <StyledChip
      size="small"
      label={label}
      style={{
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        background:
          (statusId === 'FN' && theme.palette.success.main) ||
          (statusId === 'CO' && theme.palette.info.main) ||
          (statusId === 'CA' && theme.palette.error.main) ||
          theme.palette.grey[900],
      }}
    />
  )
}

const StyledAvatar = styled(Avatar)(() => ({
  background: 'transparent',
}))

export function CollectObservation(props) {
  return (
    <StyledChip
      avatar={
        <StyledAvatar>
          <ChatDots weight="bold" fontSize="small" />
        </StyledAvatar>
      }
      size="small"
      label={props.content}
    />
  )
}
